module.exports = __webpack_public_path__ + "static/media/right-arrow.1977a75a.png";